import { render, staticRenderFns } from "./CustomerPaymentList.vue?vue&type=template&id=b5a40cbc&scoped=true&"
import script from "./CustomerPaymentList.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentList.vue?vue&type=script&lang=js&"
import style1 from "./CustomerPaymentList.vue?vue&type=style&index=1&id=b5a40cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a40cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VDataTable,VRow})
